import React from 'react';
import { IconProps } from '.';

const SvgMute = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M6.5 7 14 3v18l-7.5-4H2V7h4.5Zm6-1.5v13l-5.625-3H3.5v-7h3.375l5.625-3Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='m21.47 15.53-1.97-1.97-1.97 1.97-1.06-1.06 1.97-1.97-1.97-1.97 1.06-1.06 1.97 1.97 1.97-1.97 1.06 1.06-1.97 1.97 1.97 1.97-1.06 1.06Z'
      />
    </svg>
  );
};

export default SvgMute;
